import { PdfUserSettingsCategories } from 'modules/Shared/PdfPrint/usePdfUserSettings';

export const serviceProtocolPdfSettingsCategories: PdfUserSettingsCategories = {
	dealer: 'PdfSettingsDealer',
	customer: 'PdfSettingsCustomer',
};
